<template>
  <div>
    <div
      :class="
        id && (id == 'kanbanfilter' || id == 'kanbanpositionID')
          ? 'mt-2'
          : 'mt-3'
      "
      class="topDiv"
      ref="addedBy"
      @focusout="closeDropdownOnFocusOut"
    >
      <label
        v-if="!noLabel"
        class="acs-input-head"
        :style="id && id == 'kanbanfilter' && 'font-size: 14px !important;'"
        >{{ id == "kanbanpositionID" ? label : "Added By" }}&nbsp;</label
      >

      <div
        @click="addedByDropdown = !addedByDropdown"
        class="tp-dropdown-diffy d-flex justify-content-between pointer pointer"
      >
        <!-- newManage-dropdown-place   for selected -->
        <span
          :class="
            selectedValues.length > 0
              ? 'inputPlaceholder-font'
              : 'input-empty-placeholder'
          "
        >
          {{
            selectedValues.length == 0
              ? "Select"
              : `${selectedValues.length} Selected`
          }}
        </span>
        <span>
          <img
            v-if="!addedByDropdown"
            src="../../../assets/cvsearch/cv-downarrow.svg"
            alt=""
            class="pointer"
          />
          <img
            v-else
            class="pointer"
            src="../../../assets/cvsearch/cv-uparrow.svg"
            alt=""
          />
        </span>
      </div>
      <div
        v-if="addedByDropdown"
        class="acess-cj-filter-modal"
        style="width: 100%"
      >
        <div class="relativeclass">
          <div class="recsearchicon-pos">
            <img
              src="../../../assets/img/accessconnew/inputsearch.svg"
              alt=""
            />
          </div>
          <b-form-input
            class="acs-inputField"
            type="search"
            placeholder="Search"
            v-model="searchAddedBy"
            @input="fiterOptions"
            @keyup="fiterOptions"
          >
          </b-form-input>
          <b-form-checkbox-group
            v-if="filteredAddedByUsers.length != 0"
            v-model="selectedValues"
            :class="from == 'scroll-filter' && 'filter-dropdown'"
            :style="
              from != 'scroll-filter'
                ? 'max-height: 156px !important;'
                : 'max-height: 122px !important;'
            "
            class="
              w-100
              newManage-checkbox
              pff-checkbox pff-checkbox-added
              selectCustom-dropdown-innerContent
            "
            @change="$emit('setValue', selectedValues)"
          >
            <b-form-checkbox
              v-for="(option, index) in filteredAddedByUsers"
              :key="index"
              :value="option[id === 'kanbanpositionID' ? 'key' : 'userID']"
              :class="
                selectedValues.includes(
                  option[id === 'kanbanpositionID' ? 'key' : 'userID']
                ) && 'qb-dropdown-option-selected'
              "
            >
              <div
                v-if="id === 'kanbanpositionID'"
                class="d-flex justify-content-between align-items-center"
                style="width: 210px"
              >
                <span class="text-truncate w-70"> {{ option.label }}</span>
                <div
                  class="position-dropdown-div w-30"
                  :style="getAvatarStyle(option.status)"
                >
                  {{ getStatusName(option.status) }}
                </div>
              </div>
              <template v-else>{{ option.username }}</template>
            </b-form-checkbox>
          </b-form-checkbox-group>
          <div
            class="text-center kanban-more-option-card-input"
            v-if="filteredAddedByUsers.length == 0 && searchAddedBy !== ''"
          >
            No {{ id == "kanbanpositionID" ? label : "Users" }} found
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUsersDropdown } from "../../../utils/apiFunctions";
import {
  getAvatarStyle,
  getStatusName,
} from "../../../controllers/commonHelpers";
export default {
  name: "AddedByUsers",
  props: {
    label: String,
    noLabel: { type: Boolean, default: false },
    placeholder: String,
    id: String,
    positionIDs: Array,
    from: String,
    jobID: String,
    vmodel: {
      validator: function () {
        return true;
      },
    },
  },
  data() {
    return {
      searchAddedBy: "",
      filteredAddedByUsers: [],
      selectedValues: [],
      addedByUsers: [],
      addedByDropdown: false,
    };
  },
  watch: {
    vmodel() {
      this.selectedValues = this.vmodel;
    },
  },
  created() {
    if (this.id != "kanbanpositionID") {
      this.getUsers();
    } else {
      this.filteredAddedByUsers = this.positionIDs;
      this.addedByUsers = this.positionIDs;
    }
    if (this.vmodel) {
      this.selectedValues = this.vmodel;
    }
  },
  mounted() {
    document.addEventListener("click", this.closeDropdownOnClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeDropdownOnClickOutside);
  },
  methods: {
    getStatusName(status) {
      return getStatusName(status);
    },
    getAvatarStyle(status) {
      return getAvatarStyle(status);
    },
    closeDropdownOnClickOutside(event) {
      // Check if the clicked element is not within the component
      if (!this.$el.contains(event.target)) {
        this.addedByDropdown = false; // Close the dropdown
      }
    },
    async getUsers() {
      try {
        let payload = {};
        if (this.id == "kanbanfilter") payload.jobID = this.jobID;
        const res = await getUsersDropdown(payload);
        if (res.status == 200) {
          this.addedByUsers = res.data.data;
          this.filteredAddedByUsers = res.data.data;
        }
      } catch (error) {
        throw new Error();
      }
    },
    fiterOptions() {
      let key = this.id == "kanbanpositionID" ? "key" : "username";
      if (this.searchAddedBy == "" || this.searchAddedBy == null) {
        this.filteredAddedByUsers = this.addedByUsers;
      } else {
        // Filter options that start with the selected input
        const startsWithSelected = this.addedByUsers.filter((option) =>
          option[key].toLowerCase().startsWith(this.searchAddedBy.toLowerCase())
        );

        // Filter options that contain the selected input
        const containsSelected = this.addedByUsers.filter(
          (option) =>
            !option[key]
              .toLowerCase()
              .startsWith(this.searchAddedBy.toLowerCase()) &&
            option[key].toLowerCase().includes(this.searchAddedBy.toLowerCase())
        );

        // Concatenate startsWithSelected options followed by containsSelected options

        this.filteredAddedByUsers = [
          ...startsWithSelected,
          ...containsSelected,
        ];
      }
      this.addedByDropdown = true;
    },

    hiderAddedByDropdown() {
      this.addedByDropdown = false;
    },
    closeDropdownOnFocusOut(event) {
      let targetVal = event.relatedTarget || event.target;
      // Check if the focus is outside the custom select component
      if (!this.$refs.addedBy.contains(targetVal)) {
        this.addedByDropdown = false; // Close the dropdown
      }
    },
  },
};
</script>

<style>
.position-dropdown-div {
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-style: italic;
  font-size: 9px;
  line-height: 13px;
  text-align: center;
  width: 50px;
  border-radius: 25px;
  padding: 3px 5px;
  cursor: pointer;
}
.pff-checkbox-added .custom-control-label::after {
  top: 4px !important;
}
</style>
